export const monitoringIndicators = [
  {
    category: 'Absence Of Threats',
    sub_category: 'Biological Threat',
    indicators: [
      {
        indicator: 'Invasive Species',
        metric: 'Coverage '
      },
      {
        indicator: 'Invasive Species',
        metric: 'Height'
      },
      {
        indicator: 'Macroalgae',
        metric: 'Macroalgae Cover'
      }
    ]
  },
  {
    category: 'Absence Of Threats',
    sub_category: 'Pollution',
    indicators: [
      {
        indicator: 'Soil/Sediment',
        metric: 'Sulphide Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Total Petroleum'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Arsenic Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Cadmium Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Chromium Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Copper Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Lead Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Mercure Concentration'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Zinc Concentration'
      },
      {
        indicator: 'Water',
        metric: 'Total Petroleum'
      }
    ]
  },
  {
    category: 'Ecosystem Function',
    sub_category: 'Carbon Dynamics',
    indicators: [
      {
        indicator: 'Greenhouse Gases',
        metric: 'Fluxes'
      },
      {
        indicator: 'Litterfall',
        metric: '% Organic Matter '
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Organic Carbon Density'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Organic Matter Density'
      },
      {
        indicator: 'Vegetation',
        metric: 'Organic Carbon Density'
      }
    ]
  },
  {
    category: 'Ecosystem Function',
    sub_category: 'Nutrient Dynamics',
    indicators: [
      {
        indicator: 'Nutrient Dynamics',
        metric: 'Denitrification'
      },
      {
        indicator: 'Mycorrhiza',
        metric: 'Presence'
      },
      {
        indicator: 'Porewater',
        metric: 'Nutrients'
      },
      {
        indicator: 'Seawater',
        metric: 'Nutrients'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Nitrogen Density'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Nutrients'
      },
      {
        indicator: 'Vegetation',
        metric: 'Vegetation Nutrients '
      }
    ]
  },
  {
    category: 'Ecosystem Function',
    sub_category: 'Primary Production',
    indicators: [
      {
        indicator: 'Biomass',
        metric: 'Production'
      },
      {
        indicator: 'Diameter',
        metric: 'Growth Rate'
      },
      {
        indicator: 'Height',
        metric: 'Growth Rate'
      },
      {
        indicator: 'Leaves',
        metric: 'Productivity'
      },
      {
        indicator: 'Litter',
        metric: 'Productivity'
      },
      {
        indicator: 'Litterfall',
        metric: 'Production'
      },
      {
        indicator: 'Propagules',
        metric: 'Productivity'
      },
      {
        indicator: 'Reproductive Parts',
        metric: 'Productivity'
      },
      {
        indicator: 'Root',
        metric: 'Productivity'
      },
      {
        indicator: 'Twigs',
        metric: 'Productivity'
      }
    ]
  },
  {
    category: 'Ecosystem Function',
    sub_category: 'Secondary Production',
    indicators: [
      {
        indicator: 'Faunal Biomass',
        metric: 'Faunal Biomass Productivity'
      },
      {
        indicator: 'Faunal',
        metric: 'Faunal Growth Rate'
      },
      {
        indicator: 'Physiological',
        metric: 'Processes'
      },
      {
        indicator: 'Reproductive',
        metric: 'Characteristics'
      }
    ]
  },
  {
    category: 'Ecosystem Function',
    sub_category: 'Sediment Dynamics',
    indicators: [
      {
        indicator: 'Sediment',
        metric: 'Accretion Rate'
      },
      {
        indicator: 'Sediment',
        metric: 'Deposition'
      },
      {
        indicator: 'Sediment',
        metric: 'Elevation'
      }
    ]
  },
  {
    category: 'External Exchange',
    sub_category: 'Hydrological Connectivity',
    indicators: [
      {
        indicator: 'Flooding',
        metric: 'Duration'
      },
      {
        indicator: 'Flooding',
        metric: 'Frequency'
      },
      {
        indicator: 'Flooding',
        metric: 'Depth'
      },
      {
        indicator: 'Flooding',
        metric: 'Extent'
      }
    ]
  },
  {
    category: 'Physical Conditions',
    sub_category: 'Physico-Chemical',
    indicators: [
      {
        indicator: 'Soil/Sediment',
        metric: 'Bulk Density'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Compactness'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Grain Size'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Type'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Water Content'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Conductivity'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Dissovled Oxygen'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Moisture'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'pH'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Redox Potential'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Salinity'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Temperature'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Sulfur'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Clay Content'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Sand Content'
      },
      {
        indicator: 'Soil/Sediment',
        metric: 'Silt Content'
      },
      {
        indicator: 'Soil/Sediment Porewater',
        metric: 'Porewater Conductivity'
      },
      {
        indicator: 'Soil/Sediment Porewater',
        metric: 'Porewater pH'
      },
      {
        indicator: 'Soil/Sediment Porewater',
        metric: 'Porewater Salinity'
      },
      {
        indicator: 'Soil/Sediment Porewater',
        metric: 'Porewater Sulfate'
      },
      {
        indicator: 'Soil/Sediment Porewater',
        metric: 'Porewater Temperature'
      },
      {
        indicator: 'Water',
        metric: 'Chemical Oxygen Demand'
      },
      {
        indicator: 'Water',
        metric: 'Chlorophyll A Concentration'
      },
      {
        indicator: 'Water',
        metric: 'Dissolved Oxygen'
      },
      {
        indicator: 'Water',
        metric: 'Light Attenuation'
      },
      {
        indicator: 'Water',
        metric: 'Particulate Organic Matter Concentration'
      },
      {
        indicator: 'Water',
        metric: 'Salinity'
      },
      {
        indicator: 'Water',
        metric: 'Temperature'
      },
      {
        indicator: 'Water',
        metric: 'Total Suspended Solid'
      },
      {
        indicator: 'Water',
        metric: 'Turbidity'
      },
      {
        indicator: 'Water',
        metric: 'Clarity'
      },
      {
        indicator: 'Water',
        metric: 'pH'
      }
    ]
  },
  {
    category: 'Species Composition',
    sub_category: 'Fauna',
    indicators: [
      {
        indicator: 'Bacterial',
        metric: 'Diversity'
      },
      {
        indicator: 'Bacterial',
        metric: 'Eveness'
      },
      {
        indicator: 'Bacterial',
        metric: 'Genetic Diversity'
      },
      {
        indicator: 'Bacterial',
        metric: 'Species Richness'
      },
      {
        indicator: 'Benthic Macroinvertebrate',
        metric: 'Diversity'
      },
      {
        indicator: 'Benthic Macroinvertebrate',
        metric: 'Species Richness'
      },
      {
        indicator: 'Benthic Macrofauna',
        metric: 'Species Richness'
      },
      {
        indicator: 'Bird',
        metric: 'Diversity'
      },
      {
        indicator: 'Bird',
        metric: 'Eveness'
      },
      {
        indicator: 'Bird',
        metric: 'Species Richness'
      },
      {
        indicator: 'Epifauna',
        metric: 'Diversity'
      },
      {
        indicator: 'Epifauna',
        metric: 'Eveness'
      },
      {
        indicator: 'Epifauna',
        metric: 'Species Richness'
      },
      {
        indicator: 'Fish',
        metric: 'Diversity'
      },
      {
        indicator: 'Fish',
        metric: 'Eveness'
      },
      {
        indicator: 'Fish',
        metric: 'Species Richness'
      },
      {
        indicator: 'Fish Macroparasite',
        metric: 'Diversity'
      },
      {
        indicator: 'Fish Macroparasite',
        metric: 'Eveness'
      },
      {
        indicator: 'Fish Macroparasite',
        metric: 'Species Richness'
      },
      {
        indicator: 'Gastropod',
        metric: 'Presence'
      },
      {
        indicator: 'Infauna',
        metric: 'Diversity'
      },
      {
        indicator: 'Infauna',
        metric: 'Eveness'
      },
      {
        indicator: 'Infauna',
        metric: 'Species Richness'
      },
      {
        indicator: 'Invertebrate',
        metric: 'Presence'
      },
      {
        indicator: 'Invertebrate',
        metric: 'Diversity'
      },
      {
        indicator: 'Macrozoobenthic',
        metric: 'Diversity'
      },
      {
        indicator: 'Macrozoobenthic',
        metric: 'Eveness'
      },
      {
        indicator: 'Nekton',
        metric: 'Diversity'
      },
      {
        indicator: 'Nekton',
        metric: 'Species Richness'
      }
    ]
  },
  {
    category: 'Species Composition',
    sub_category: 'Flora',
    indicators: [
      {
        indicator: 'Vegetation',
        metric: 'Diversity'
      },
      {
        indicator: 'Vegetation',
        metric: 'Cover'
      },
      {
        indicator: 'Vegetation',
        metric: 'Presence'
      },
      {
        indicator: 'Vegetation',
        metric: 'Species Richness'
      }
    ]
  },
  {
    category: 'Structural Diversity',
    sub_category: 'Fauna',
    indicators: [
      {
        indicator: 'Algal',
        metric: 'Density'
      },
      {
        indicator: 'Bacterial',
        metric: 'Density'
      },
      {
        indicator: 'Bacterial',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Amphipod',
        metric: 'Density'
      },
      {
        indicator: 'Benthic Macroinvertebrate',
        metric: 'Biomass'
      },
      {
        indicator: 'Benthic Macroinvertebrate',
        metric: 'Density'
      },
      {
        indicator: 'Benthic Macrofauna',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Benthic Macrofauna',
        metric: 'Density'
      },
      {
        indicator: 'Benthos',
        metric: 'Biomass'
      },
      {
        indicator: 'Benthos',
        metric: 'Density'
      },
      {
        indicator: 'Bird',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Bird',
        metric: 'Density'
      },
      {
        indicator: 'Bivalve',
        metric: 'Biomass'
      },
      {
        indicator: 'Bivalve',
        metric: 'Density'
      },
      {
        indicator: 'Crab',
        metric: 'Density'
      },
      {
        indicator: 'Crab',
        metric: 'Shell Width'
      },
      {
        indicator: 'Epifauna',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Epifauna',
        metric: 'Density'
      },
      {
        indicator: 'Fauna',
        metric: 'Phylum Assemblage'
      },
      {
        indicator: 'Fish',
        metric: 'Age Class Distribution'
      },
      {
        indicator: 'Fish',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Fish',
        metric: 'Biomass'
      },
      {
        indicator: 'Fish',
        metric: 'Density'
      },
      {
        indicator: 'Fish',
        metric: 'Length'
      },
      {
        indicator: 'Fish Macroparasite',
        metric: 'Density'
      },
      {
        indicator: 'Gastropod',
        metric: 'Biomass'
      },
      {
        indicator: 'Gastropod',
        metric: 'Density'
      },
      {
        indicator: 'Gastropod',
        metric: 'Shell Length'
      },
      {
        indicator: 'Infauna',
        metric: 'Density'
      },
      {
        indicator: 'Invertebrates',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Isopod',
        metric: 'Density'
      },
      {
        indicator: 'Macrofaunal Invertebrate',
        metric: 'Density'
      },
      {
        indicator: 'Macrozoobentic',
        metric: 'Density'
      },
      {
        indicator: 'Mud Crabs',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Mud Crabs',
        metric: 'Size Distribution'
      },
      {
        indicator: 'Nekton',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Nekton',
        metric: 'Biomass'
      },
      {
        indicator: 'Nekton',
        metric: 'Density'
      },
      {
        indicator: 'Nekton',
        metric: 'Habitat Preference'
      },
      {
        indicator: 'Nekton',
        metric: 'Length'
      },
      {
        indicator: 'Nekton',
        metric: 'Life Stage'
      },
      {
        indicator: 'Nekton',
        metric: 'Trophic Category'
      },
      {
        indicator: 'Pelagic Invertebrate',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Pelagic Invertebrate',
        metric: 'Biomass'
      },
      {
        indicator: 'Pelagic Invertebrate',
        metric: 'Density'
      },
      {
        indicator: 'Polychaete',
        metric: 'Density'
      },
      {
        indicator: 'Shrimp',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Shrimp',
        metric: 'Density'
      },
      {
        indicator: 'Terrestrial Invertebrate',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Terrestrial Invertebrate',
        metric: 'Biomass'
      },
      {
        indicator: 'Terrestrial Invertebrate',
        metric: 'Density'
      }
    ]
  },
  {
    category: 'Structural Diversity',
    sub_category: 'Food Web',
    indicators: [
      {
        indicator: 'Arthropode',
        metric: 'Isotopic Signature'
      },
      {
        indicator: 'Fish',
        metric: 'Diet Composition'
      },
      {
        indicator: 'Fish',
        metric: 'Isotopic Signature'
      },
      {
        indicator: 'Fish',
        metric: 'Prey Selectivity'
      },
      {
        indicator: 'Mussel',
        metric: 'Diet Composition'
      },
      {
        indicator: 'Mussel',
        metric: 'Isotopic Signature'
      },
      {
        indicator: 'Spider',
        metric: 'Diet Composition'
      },
      {
        indicator: 'Suspended Organic Matter ',
        metric: 'Isotopic Signature'
      },
      {
        indicator: 'Vegetation',
        metric: 'Isotopic Signature'
      }
    ]
  },
  {
    category: 'Structural Diversity',
    sub_category: 'Flora',
    indicators: [
      {
        indicator: 'Canopy',
        metric: 'Closure'
      },
      {
        indicator: 'Mangrove',
        metric: 'Cover'
      },
      {
        indicator: 'Mangrove',
        metric: 'Aboveground Biomass'
      },
      {
        indicator: 'Mangrove',
        metric: 'Basal Area'
      },
      {
        indicator: 'Mangrove',
        metric: 'Belowground Biomass'
      },
      {
        indicator: 'Mangrove',
        metric: 'Crown Diameter'
      },
      {
        indicator: 'Mangrove',
        metric: 'Dbh'
      },
      {
        indicator: 'Mangrove',
        metric: 'Structural Complexity Index'
      },
      {
        indicator: 'Mangrove',
        metric: 'Vegetation Development'
      },
      {
        indicator: 'Mangrove',
        metric: 'Biomass'
      },
      {
        indicator: 'Mangrove',
        metric: 'Juvenile/Sapling Density'
      },
      {
        indicator: 'Mangrove',
        metric: 'Juvenile/Sapling Height'
      },
      {
        indicator: 'Mangrove',
        metric: 'Leaf Area Index'
      },
      {
        indicator: 'Mangrove',
        metric: 'Density'
      },
      {
        indicator: 'Mangrove',
        metric: 'Height'
      },
      {
        indicator: 'Vegetation',
        metric: 'Cover'
      },
      {
        indicator: 'Vegetation',
        metric: 'Taxonomic Assemblage'
      },
      {
        indicator: 'Halophytes',
        metric: 'Density'
      },
      {
        indicator: 'Rhizome',
        metric: 'Biomass'
      },
      {
        indicator: 'Rhizome',
        metric: 'Density'
      },
      {
        indicator: 'Mangrove Root',
        metric: 'Biomass'
      },
      {
        indicator: 'Mangrove Root',
        metric: 'Density'
      },
      {
        indicator: 'Mangrove Root',
        metric: 'Root:Shoot Ratio'
      }
    ]
  }
]
